import { render, staticRenderFns } from "./otaActivate.vue?vue&type=template&id=d270e5f0&scoped=true"
import script from "./otaActivate.vue?vue&type=script&lang=js"
export * from "./otaActivate.vue?vue&type=script&lang=js"
import style0 from "./otaActivate.vue?vue&type=style&index=0&id=d270e5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d270e5f0",
  null
  
)

export default component.exports